export const consts = {
  SOURCE_TYPE_TASK: 1,
  SOURCE_TYPE_LEARNING_CENTER: 2,
  SOURCE_TYPE_ASSIGN: 3,

  STATUS_LEARNING: 1,
  STATUS_LEARN_FINISHED: 2,
  STATUS_WAIT_EXAM: 3,
  STATUS_ON_EXAM: 4,
  STATUS_PASSED: 5,
  STATUS_EXAM_NOT_PASS: 6,
  STATUS_EXAM_WAIT_RETRY: 7,

  EXAMINATION_STATUS_NOT_START: 0,
  EXAMINATION_STATUS_WAIT_SUBMIT: 1,
  EXAMINATION_STATUS_PASS: 2,
  EXAMINATION_STATUS_NOT_PASS: 3,
  EXAMINATION_STATUS_SUBMITTED: 4,
}

export const opts = {
  sourceTypeMaps: [
    { value: consts.SOURCE_TYPE_TASK, label: '批次任务' },
    { value: consts.SOURCE_TYPE_LEARNING_CENTER, label: '学习中心' },
    { value: consts.SOURCE_TYPE_ASSIGN, label: '管理员分配' },
  ],
  recordStatusMaps: [
    { value: consts.STATUS_LEARNING, label: '学习中' },
    { value: consts.STATUS_LEARN_FINISHED, label: '已学完' },
    { value: consts.STATUS_WAIT_EXAM, label: '待考试' },
    { value: consts.STATUS_ON_EXAM, label: '考试中' },
    { value: consts.STATUS_PASSED, label: '通过' },
    { value: consts.STATUS_EXAM_NOT_PASS, label: '考试未通过' },
    { value: consts.STATUS_EXAM_WAIT_RETRY, label: '待重考' },
  ],
  examinationStatusMaps: [
    { value: consts.EXAMINATION_STATUS_NOT_START, label: '未开始' },
    { value: consts.EXAMINATION_STATUS_WAIT_SUBMIT, label: '待提交' },
    { value: consts.EXAMINATION_STATUS_PASS, label: '通过' },
    { value: consts.EXAMINATION_STATUS_NOT_PASS, label: '不通过' },
    { value: consts.EXAMINATION_STATUS_SUBMITTED, label: '已提交' },
  ],
}

export const TRAINING_INSTRUCTION_RECORD_TABLE_COLUMN_STORAGE_KEY = 'training-instruction-record-list'
export const TRAINING_INSTRUCTION_EXAM_RECORD_TABLE_COLUMN_STORAGE_KEY = 'training-instruction-exam-record-list'



// WEBPACK FOOTER //
// ./src/views/training/training-instruction-record.constants.js